module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTPro-Bd.ba66962b.otf";